<template>
  <div class="contentBar">
    <div class="header">
      <div class="left">{{ startTime }}~{{ endTime }}</div>
      <div class="right">{{ contentName }}</div>
    </div>
    <div class="center">{{ position }}</div>
    <div class="bottom">
      <div class="left">{{ contentTitle }}：</div>
      <div class="right">{{ content }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    startTime: {
      type: String
    },
    endTime: {
      type: String
    },
    contentName: {
      type: String
    },
    position: {
      type: String
    },
    contentTitle: {
      type: String
    },
    content: {
      type: String
    }
  }
}
</script>

<style lang="less" scoped>
.contentBar {
  border: 1px solid #e6e6e6;
  margin: 0 30px 20px;
  padding: 16px;
  .header,
  .bottom {
    display: flex;
    .left {
      min-width: 160px;
    }
  }
  .header {
    .left {
      font-size: 14px;
      color: #999999;
    }
    .right {
      font-size: 16px;
      color: #333333;
    }
  }
  .center,
  .bottom {
    font-size: 14px;
    color: #333333;
  }
  .center {
    margin-left: 160px;
    padding: 10px 0;
  }
}
</style>
